import { patientActions, diaryActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.diary };
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.id];
            }
        })
    },

    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.patientsContainer.entities) {
            return { ...state, ...action.payload.patientsContainer.entities.diary };
        } else {
            return state;
        }
    },

    [diaryActions.saveDiaryFailure]: (state, action) => {
        log.error('Save diary error for ptno: ' + action.payload.ptno + ' error: ' + action.payload.error);
        return state;
    },
    [patientActions.loadDiarySuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.diary };
    }

})


